import * as React from 'react';
import { SVGProps } from 'react';
import SecureGuaranteed_e from './SecureGuaranteed-e.webp';
import SecureGuaranteed_f from './SecureGuaranteed-f.webp';
import SecureGuaranteed_g from './SecureGuaranteed_g.webp';
import SecureGuaranteed_h from './SecureGuaranteed_h.webp';

const SecureGuaranteed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={55}
    fill="none"
    {...props}>
    <g opacity={0.8}>
      <path fill="url(#a)" d="M102.912 5.79h43.689v43.421h-43.689z" />
      <path fill="url(#b)" d="M155.34 0H200v50.175h-44.66z" />
      <path fill="url(#c)" d="M0 2.895h49.515V55H0z" />
      <path fill="url(#d)" d="M50.486 1.93h43.689v47.281H50.486z" />
    </g>
    <defs>
      <pattern
        id="a"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox">
        <use href="#e" transform="scale(.00633)" />
      </pattern>
      <pattern
        id="b"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox">
        <use href="#f" transform="scale(.0065 .00581)" />
      </pattern>
      <pattern
        id="c"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox">
        <use href="#g" transform="scale(.00552 .00524)" />
      </pattern>
      <pattern
        id="d"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox">
        <use href="#h" transform="scale(.00662 .00592)" />
      </pattern>
      <image id="e" width={158} height={158} href={SecureGuaranteed_e} />
      <image id="f" width={154} height={172} href={SecureGuaranteed_f} />
      <image id="g" width={181} height={191} href={SecureGuaranteed_g} />
      <image id="h" width={151} height={169} href={SecureGuaranteed_h} />
    </defs>
  </svg>
);

export default SecureGuaranteed;
